import { render, staticRenderFns } from "./Jubotron.vue?vue&type=template&id=02362873&"
import script from "./Jubotron.vue?vue&type=script&lang=js&"
export * from "./Jubotron.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports